import { render, staticRenderFns } from "./RankTop3Item.vue?vue&type=template&id=0acbcde4"
import script from "./RankTop3Item.vue?vue&type=script&lang=js"
export * from "./RankTop3Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports